module.exports = __webpack_public_path__ + "static/img/fission-activity-detail-banner.cf7464f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/fission-activity-detail-banner.png
// module id = mVs6
// module chunks = 216